/*
 * @Author: zloongjiang
 * @Date:   2019-05-05 22:25:04
 * @Last Modified by: zloongjiang
 * @Last Modified time: 2019-05-24 09:59:43
 */
import React from 'react';
import PropTypes from 'prop-types';
import { listenToScroll, visible } from '../../utility/DOM';
import { track } from '../../utility';
if (__CLIENT__) {
  require('./index.scss');
}
type listType = {
  id: string,
  title: string,
  image: string,
  playTime: string,
  playCount: string,
  url: string,
};
type Props = {
  listData: Array<listType>,
};
// 小视频

class UgcVideo extends React.PureComponent {
  prps: Props;
  componentDidMount() {
    let { el } = this;
    if (!el) {
      return;
    }
    el = el.childNodes[0]; // 取内容节点
    if (visible(el)) {
      this.watchExposure();
      return;
    }
    const watch = listenToScroll(() => {
      if (visible(el)) {
        this.watchExposure();
        watch.remove();
      }
    });
  }
  watchExposure = () => {
    track({
      location: 'sharelp',
      action: 'exposure',
      object: 'sharelp_SMVD01',
      ch: '060000',
    });
  };
  render() {
    const { listData, onClick = () => {} } = this.props;
    const clickParam = {
      docId: '',
      tagId: '',
      isGallery: '',
      url: '',
      share: true,
      fromType: 'configure_ugcvideo',
    };
    return (
      <div
        className="float_video_list"
        ref={(el) => {
          this.el = el;
        }}
      >
        {listData.map((item, key) => (
          <div
            className={`float_video_item ${key % 2 === 1 ? 'even' : ''}`}
            style={{ backgroundImage: `url(${item.image || (item.thumbs && item.thumbs[0])})` }}
            key={`float_video_key${item.id}${key}`}
            onClick={(e) => {
              clickParam.url = item.url;
              onClick(e, clickParam);
            }}
          >
            <div className="ugc_video_inner">
              <div className="ugc_video_header">
                <span className="tag"></span>
                <p className="title">{item.title}</p>
              </div>
              <div className="ugc_video_play"></div>
              <div className="ugc_video_footer">
                {item.playCount && <span className="play-count">{item.playCount}</span>}
                {item.playTime && <span className="play-time">{item.playTime}</span>}
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }
}
UgcVideo.propTypes = {
  listData: PropTypes.object,
  onClick: PropTypes.func,
};
export default UgcVideo;
